import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../lib/constants/apis';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import VerwendungsNachweisSchema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsNachweisSchema.attributes;

const ProjektDatenVN: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, printMode } = useApplication();
	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />

			<CreateForm
				formStruc={formStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				api={APIS.Antrag}
				printMode={printMode}
			/>
		</>
	);
};

export default ProjektDatenVN;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Von, disabled: true },
				{ ...VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Bis, disabled: true },
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

export const getFormStrucProjektDatenVN = () => {
	return concat(formStruc());
};
